import { render, staticRenderFns } from "./calls.vue?vue&type=template&id=ed0d46e6&"
import script from "./calls.vue?vue&type=script&lang=js&"
export * from "./calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports